export class TooltipValue
{
    // color: string;
    // value?: number;

    constructor (public label: string, public color: string, public value?: number)
    {
        // this.color = color;
        // this.value = value;
    }
}

export class TooltipData
{
    public posX: number;
    public posY: number;
    public values: TooltipValue[];
    public unit: string;
    public yFormatTick: (value: number) => (string);

    constructor (public title?: string)
    {
        this.values = [];
    }
}
